import LegalPage from '../../components/LegalPage';
import CardNB from '../../components/ui-nb/CardNB';

export default function PrivacyPage() {
  const today = new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' });

  return (
    <LegalPage
      title="Politique de Confidentialité"
      lastUpdated={`Dernière mise à jour: ${today}`}
    >
      <CardNB>
        <div className="space-y-8">
          <p className="text-lg text-nb-text-secondary">
            Tellow Up! ("nous", "notre", ou "nos") s'engage à protéger votre vie privée. Cette politique explique comment nous collectons, utilisons et protégeons vos informations.
          </p>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Responsable du Traitement</h2>
            <p className="text-nb-text-secondary">
              Tellow Up! est responsable de vos données personnelles. Pour toute question, contactez-nous à privacy@tellowup.com.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Données que Nous Collectons</h2>
            <ul className="list-disc pl-5 space-y-1 text-nb-text-secondary">
              <li>Données d'identité: nom, adresse email, informations Google OAuth</li>
              <li>Données d'organisation: nom du magasin, code du magasin, état de l'abonnement</li>
              <li>Données de suivi: codes de libération, état de réparation, horodatages</li>
              <li>Données d'utilisation: journaux d'accès, informations de l'appareil, adresse IP</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Finalité et Base Légale</h2>
            <p className="mb-3 text-nb-text-secondary">
              Nous traitons vos données pour: (a) fournir et maintenir le service; (b) vous informer des changements; (c) fournir un support client; (d) détecter et prévenir la fraude. Base légale: consentement pour les données d'identité, intérêt légitime pour l'analyse d'utilisation.
            </p>
            <p className="font-medium text-nb-text-secondary">Base Légale:</p>
            <ul className="list-disc pl-5 space-y-1 text-nb-text-secondary">
              <li>Fournir le service SaaS</li>
              <li>Améliorer notre plateforme</li>
              <li>Envoyer des notifications relatives au service</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Partage des Données</h2>
            <p className="text-nb-text-secondary">
              Nous ne vendons pas vos données. Nous partageons des données avec: (a) Supabase (notre fournisseur backend, données stockées aux États-Unis); (b) Google (authentification OAuth). Tous les fournisseurs sont liés par des accords de traitement.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Données de Paiement</h2>
            <p className="text-nb-text-secondary">
              Le traitement des paiements est géré par Stripe. Nous ne stockons pas les détails complets de votre carte de crédit. Stripe peut collecter et traiter les données de paiement selon sa politique de confidentialité. Nous ne recevons que la confirmation du statut du paiement.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Transferts Internationaux</h2>
            <p className="text-nb-text-secondary">
              Les données peuvent être transférées et traitées aux États-Unis. Pour les utilisateurs de l'UE, nous assurons des garanties appropriées conformément au RGPD.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Conservation des Données</h2>
            <p className="text-nb-text-secondary">
              Nous conservons vos données tant que votre compte est actif et pendant 12 mois après la suppression. Les enregistrements financiers sont conservés 7 ans selon les exigences légales.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Enregistrements Financiers</h2>
            <p className="text-nb-text-secondary">
              Nous conservons les enregistrements financiers pendant 7 ans selon les exigences légales pour des fins fiscales et de conformité.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Vos Droits</h2>
            <p className="mb-3 text-nb-text-secondary">
              Vous avez le droit de: accéder, rectifier, effacer, limiter le traitement, vous opposer au traitement et porter vos données. Contactez privacy@tellowup.com pour exercer vos droits.
            </p>
            <ul className="list-disc pl-5 space-y-1 text-nb-text-secondary">
              <li>Accéder à vos données</li>
              <li>Corriger des données inexactes</li>
              <li>Demander la suppression</li>
              <li>Portabilité des données</li>
              <li>Retirer le consentement à tout moment</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Cookies</h2>
            <p className="text-nb-text-secondary">
              Nous n'utilisons pas de cookies propriétaires. Google OAuth peut utiliser des cookies selon sa politique de confidentialité. Nous ne suivons pas les utilisateurs entre sites web.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Confidentialité des Enfants</h2>
            <p className="text-nb-text-secondary">
              Notre service n'est pas destiné aux utilisateurs de moins de 16 ans. Nous ne collectons pas consciemment de données auprès des enfants. Si nous apprenons une telle collecte, nous supprimerons les données.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Modifications de Cette Politique</h2>
            <p className="text-nb-text-secondary">
              Nous vous notifierons des modifications par email ou avis sur le site. L'utilisation continue après les modifications constitue l'acceptation.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Contact</h2>
            <p className="text-nb-text-secondary">
              Pour toute préoccupation concernant la confidentialité, contactez notre Responsable de la Protection des Données à privacy@tellowup.com.
            </p>
          </section>
        </div>
      </CardNB>
    </LegalPage>
  );
}
